































import { Component, Watch, Vue } from "vue-property-decorator";


@Component({
    components: {
    },
    computed: {
    },
})
export default class CheckinListViewPlayList extends Vue {

    htmlBody = "";
    tables: any = null;
    table: any = null;
    tableXml: any = null;
    tableJson: any = null;
    tableLastUpdate = null;
    body = this.createElementFromHTML("<div style='height: 100%;' class=''></div>");
    lastIndex = 0;
    pageTimer: any = null;
    @Watch("body", { deep: true })
  onFilterChanged() {
    //this.htmlBody = this.body.outerHTML;
  }


    async loadTables() {
        this.$store.commit("main/SET_LOADING", true);
        
        try {
            var playlist = this.$route.params.p;
            this.tables = await this.$store.dispatch("schedule/getWaitingListTables", playlist);

            for (let i = 0; i < this.tables.length; i++) {

                const container = this.body.querySelector("div") as HTMLElement;
                const iframe = document.createElement("iframe")

                iframe.style.width = (100.0 / this.tables.length) + "%";
                iframe.src = this.$router.resolve({name: 'checkin-list', params: {t: this.tables[i].TableID}}).href;
                container.append(iframe);
               
            }


            this.resizeContainer();

            this.htmlBody = this.body.outerHTML;

        } catch (error) {
            console.log(error);
        } finally {
            this.$store.commit("main/SET_LOADING", false);
        }
    }

    createElementFromHTML(htmlString) {
    var template = document.createElement('div');
    template.innerHTML = htmlString.trim();
    return template;
  }

  resizeContainer() {
      const container = this.body.querySelector("div") as HTMLElement;
      container.style.height = window.innerHeight.toString() + "px"; 
    }

    mounted() {
        this.loadTables();
        window.onresize = this.resizeContainer;
    }
}
